<template>
  <div class="cash_wrap" >
    <van-form @submit="onSubmit" >
      <div class="cash_card" >
        <div class="cash_title" >用户认证</div>
        <div class="cash_form_item" >
          <div class="cash_form_item_label" >真实姓名</div>
          <van-field placeholder="请输入真实姓名" class="form_item_input" name="realName" v-model="form.realName"
                     :rules="[{ required: true, message: '' }]"
          />
        </div>

        <div class="cash_form_item" >
          <div class="cash_form_item_label" >身份证</div>
          <van-field placeholder="请输入身份证号" class="form_item_input" name="idCard" v-model="form.idCard"
                     :rules="[{ required: true, message: '' }]"
          />
        </div>
      </div>

      <van-button class="cash_apply_btn" type="info" native-type="submit" :loading="submitting" >开始认证</van-button>
    </van-form>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  userAuth
} from '@/api/login'
import {
  Toast
} from 'vant'
export default {
  name: 'userAuth',
  data() {
    return {
      form: {},
      submitting: false,
    }
  },
  methods: {
    onSubmit() {
      console.log({...this.form})
      this.submitting = true
      userAuth({...this.form}).then(res => {
        this.submitting = false
        console.log(res)
        if(res.success) {
          Toast('认证成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    }
  },
  mounted() {

  }
}
</script>
